import React, { createContext, useCallback, useState } from 'react';
import { useVisualViewport } from '../../hooks/useVisualViewport';
import c from 'classnames';
import ddt from '@wix/da-ddt';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './AbsoluteHeightLayout.scss';
/**
 * Context allowing setting of the scrollable for body locking and also
 * height for inner components
 */ export const AbsoluteHeightLayoutContext = /*#__PURE__*/ createContext({
    height: 0
});
AbsoluteHeightLayoutContext.displayName = 'AbsoluteHeightLayoutContext';
/**
 * Deals with the times where you want a fixed layout that scrolls but also
 * works on IOS where screen height is never right and 100vh is broken.
 *
 * This applies:
 * - visualViewport height/offset/scale a wrapping div
 *
 * Assumes:
 * - The layout is a fixed height
 *
 * Provides:
 * - AbsoluteHeightLayoutContext for easy access to the height in children
 *
 * Notes:
 * - You probably also want to use body scroll locking on all the scrollable areas in your fixed layout
 * - When using this you "probably" want to disable the fixed positioning of the header, there is a
 *   flag on the site header component for that. This makes working with IOS keyboard much easier.
 *
 * See stories for example
 *
 * @deprecated Use dvh instead, ios finally fixed it so you can use css + scroll locking and it work with keyboard
 */ const AbsoluteHeightLayout = ({ children, className, heightReduction, withScale = false, disableIfDvSupported = false })=>{
    const is_nc_ios = useFlag('nc_ios');
    const [visualViewport, setVisualViewport] = useState();
    const viewportHandler = useCallback((v)=>{
        setVisualViewport(v);
    }, []);
    useVisualViewport(viewportHandler, true);
    let styles = {};
    let calculatedHeight = 0;
    if (visualViewport) {
        calculatedHeight = heightReduction ? visualViewport.height - heightReduction : visualViewport.height;
        styles = {
            height: calculatedHeight,
            transform: visualViewport.offsetLeft > 0 || visualViewport.offsetTop > 0 ? `translate(${visualViewport.offsetLeft}px,${visualViewport.offsetTop}px)` : undefined,
            scale: withScale ? visualViewport.scale : undefined
        };
    }
    if (is_nc_ios && disableIfDvSupported && typeof window !== 'undefined' && CSS.supports('height', '1dvh')) {
        ddt.log('layout', 'Disabled abs height using DVH');
        return /*#__PURE__*/ React.createElement(AbsoluteHeightLayoutContext.Provider, {
            value: {
                height: false
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: c(s['root'], className)
        }, children));
    }
    return /*#__PURE__*/ React.createElement(AbsoluteHeightLayoutContext.Provider, {
        value: {
            height: calculatedHeight
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: styles
    }, children));
};
AbsoluteHeightLayout.displayName = 'AbsoluteHeightLayout';
export default AbsoluteHeightLayout;

//# sourceMappingURL=AbsoluteHeightLayout.js.map